export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5481.5631e40e.jpg";